(() => {
  const waitForGsap = () =>
    new Promise((resolve) => {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        resolve();
        return;
      }
      const check = setInterval(() => {
        if (window.gsap && window.ScrollTrigger) {
          clearInterval(check);
          window.gsap.registerPlugin(window.ScrollTrigger);
          resolve();
        }
      }, 50);
    });

  class SaFollowUs {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.dataEl = document.getElementById(`sa-follow-us-data-${this.sectionId}`);
      this.items = this.dataEl ? JSON.parse(this.dataEl.textContent) : [];
      this.grid = root.querySelector('.masonry-grid');
      this.modal = root.querySelector('.modal');
      this.modalSwiperEl = root.querySelector('.modal-swiper');
      this.modalSwiperWrapper = root.querySelector('.modal-swiper-wrapper');
      this.modalVideoEl = root.querySelector('.modal__media-video');
      this.modalPlayBtn = root.querySelector('.modal__play');
      this.modalProductsEl = root.querySelector('.modal__products');
      this.modalDescEl = root.querySelector('.modal__desc');
      this.scrollTriggers = [];
      this.timelines = [];
      this.columnCount = null;
      this.modalSwiper = null;
      this.resizeTimer = null;
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const cols = this.getColumnCount();
          if (cols !== this.columnCount) {
            this.init();
          }
        }, 200);
      };

      this.bindEvents();
      this.init();
    }

    bindEvents() {
      this.root.querySelectorAll('[data-close-modal]').forEach((el) => {
        el.addEventListener('click', () => this.closeModal());
      });
        // 点击蒙层（弹框内容区域外）关闭
  this.modal?.addEventListener('click', (event) => {
    const dialog = this.modal.querySelector('.modal__dialog');
    if (dialog?.contains(event.target)) return;
    this.closeModal();
  });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal?.classList.contains('is-open')) {
          this.closeModal();
        }
      });

      this.modalPlayBtn?.addEventListener('click', () => {
        if (!this.modalVideoEl) return;
        if (this.modalVideoEl.paused) {
          this.modalVideoEl.play();
          this.modalPlayBtn.classList.remove('is-visible');
        }
      });

      window.addEventListener('resize', this.onResize);
    }

    getMediaImages(item) {
      const list = item.images?.length ? item.images : item.cover ? [item.cover] : [];
      return list.slice(0, 3);
    }

    destroyModalSwiper() {
      if (this.modalSwiper) {
        this.modalSwiper.destroy(true, true);
        this.modalSwiper = null;
      }
    }

    initModalSwiper(images, alt) {
      this.destroyModalSwiper();
      if (!this.modalSwiperWrapper || !this.modalSwiperEl || typeof window.Swiper === 'undefined') return;

      this.modalSwiperWrapper.innerHTML = images
        .map(
          (src) => `
            <div class="swiper-slide">
              <img class="modal__media-img block size-full object-cover" src="${src}" alt="${alt}" loading="lazy" />
            </div>
          `,
        )
        .join('');

      this.modalSwiperEl.classList.toggle('is-single', images.length <= 1);

      if (images.length <= 1) return;

      this.modalSwiper = new window.Swiper(this.modalSwiperEl, {
        loop: false,
        speed: 400,
        pagination: {
          el: this.root.querySelector('.modal-swiper__pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.root.querySelector('.modal-swiper__next'),
          prevEl: this.root.querySelector('.modal-swiper__prev'),
        },
      });
    }

    setModalVideo(item) {
      if (!this.modalVideoEl || !this.modalSwiperEl) return;

      if (item.modalType === 'video' && item.videoUrl) {
        this.modalSwiperEl.classList.add('hidden');
        this.modalVideoEl.classList.remove('hidden');
        if (item.cover) this.modalVideoEl.poster = item.cover;
        this.modalVideoEl.src = item.videoUrl;
        this.modalVideoEl.load();
        this.modalPlayBtn?.classList.add('is-visible');
      } else {
        this.modalSwiperEl.classList.remove('hidden');
        this.modalVideoEl.classList.add('hidden');
        this.modalVideoEl.pause();
        this.modalVideoEl.removeAttribute('src');
        this.modalPlayBtn?.classList.remove('is-visible');
      }
    }

    renderProductCard(product, layout) {
      const compareHtml = product.compareAt
        ? `<span class="text-[12px] font-400 leading-16 font-[Poppins] text-[#00000080] line-through md:text-[14px] md:leading-20">${product.compareAt}</span>`
        : '';

      if (layout === 'video') {
        return `
          <article class="flex gap-8 md:gap-16">
            <a href="${product.url}" class="shrink-0">
              <img
                class="block h-80 w-80 rounded-[12px] object-cover md:h-130 md:w-130"
                src="${product.image}"
                alt="${product.title}"
                loading="lazy"
              />
            </a>
            <div class="flex min-w-0 flex-1 flex-col justify-between">
              <h3 class="mb-0 mt-0 text-[12px] font-medium leading-[1.3] md:leading-24 md:text-[16px] font-[Poppins] text-[#000000CC] overflow-hidden line-clamp-1 md:line-clamp-2">
                <a href="${product.url}" class="text-inherit no-underline">${product.title}</a>
              </h3>
              <div class="md:mt-4 flex items-baseline gap-6">
                <span class="text-[14px] md:text-[16px] font-semibold text-[#000000F2]">${product.price}</span>
                ${compareHtml}
              </div>
              ${product.formHtml || ''}
            </div>
          </article>
        `;
      }

      return `
        <article class="flex flex-col items-center max-md:items-stretch">
          <a href="${product.url}" class="w-full max-md:block md:h-160 md:w-160">
            <img
              class="block aspect-square w-full rounded-[12px] object-cover md:rounded-[10px]"
              src="${product.image}"
              alt="${product.title}"
              loading="lazy"
            />
          </a>
          <h3 class="mb-0 mt-4 line-clamp-2 text-center text-[14px] font-400 leading-20 font-[Poppins] text-[#000000CC] md:mt-8 md:font-medium md:leading-[1.3]">
            <a href="${product.url}" class="text-inherit no-underline">${product.title}</a>
          </h3>
          <div class="mt-4 flex items-baseline justify-center gap-[2px] md:gap-6">
            <span class="text-[14px] font-400 leading-20 font-[Poppins] text-[#000000F2] md:text-[16px] md:leading-24">${product.price}</span>
            ${compareHtml}
          </div>
          <div class="w-full max-md:mt-8">
            ${product.formHtml || ''}
          </div>
        </article>
      `;
    }

    renderModalProducts(item) {
      if (!this.modalProductsEl) return; 

      const isVideo = item.modalType === 'video';
      const products = isVideo ? item.products.slice(0, 1) : item.products.slice(0, 4);

      this.modalProductsEl.classList.toggle('is-video-layout', isVideo);
      this.modalProductsEl.innerHTML = products
        .map((product) => this.renderProductCard(product, isVideo ? 'video' : 'grid'))
        .join('');
    }

    getColumnCount() {
      const desktop = Number.parseInt(this.root.dataset.columnsDesktop, 10) || 5;
      const tablet = Number.parseInt(this.root.dataset.columnsTablet, 10) || 3;
      const mobile = Number.parseInt(this.root.dataset.columnsMobile, 10) || 2;

      if (window.innerWidth <= 500) return mobile;
      if (window.innerWidth <= 766) return tablet;
      return desktop;
    }

    renderCard(item, index) {
      if (!item.cover) return '';
      const alt = item.alt || `Item ${index + 1}`;
      return `
        <button type="button" class="col relative my-0 md:my-12 aspect-[370/560] h-auto w-full cursor-pointer border-0 bg-transparent p-0 text-left" data-index="${index}" aria-label="Open item ${index + 1}">
          <div class="inner pointer-events-none relative h-full w-full overflow-hidden rounded-[15px]">
            <img
              src="${item.cover}"
              alt="${alt}"
              class="testimonial-image block size-full object-contain"
              loading="lazy"
            />
          </div>
        </button>
      `;
    }

    buildMasonry() {
      if (!this.grid) return;

      const cols = this.getColumnCount();
      const columns = Array.from({ length: cols }, () => []);
      const validItems = this.items.filter((item) => item.cover);

      validItems.forEach((item) => {
        columns[item.index % cols].push(item);
      });

      this.grid.innerHTML = columns
        .filter((entries) => entries.length)
        .map(
          (entries) => `
            <div class="main-col flex min-w-0 flex-1 flex-col gap-8 md:gap-0">
              ${entries.map((item) => this.renderCard(item, item.index)).join('')}
            </div>
          `,
        )
        .join('');

      this.grid.querySelectorAll('.col[data-index]').forEach((card) => {
        card.addEventListener('click', () => {
          this.openModal(Number(card.dataset.index));
        });
      });
    }

    openModal(index) {
      const item = this.items.find((entry) => entry.index === index);
      if (!item || !this.modal) return;

      if (item.modalType === 'video') {
        this.setModalVideo(item);
      } else {
        this.setModalVideo({ modalType: 'image' });
        this.initModalSwiper(this.getMediaImages(item), item.alt || '');
      }

      this.renderModalProducts(item);

      if (this.modalDescEl) {
        this.modalDescEl.innerHTML = item.description || '';
        this.modalDescEl.style.display = item.description ? '' : 'none';
      }

      this.modal.classList.toggle('is-image-modal', item.modalType !== 'video');
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.classList.remove('is-open', 'is-image-modal');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      this.destroyModalSwiper();
      this.modalVideoEl?.pause();
      this.modalPlayBtn?.classList.remove('is-visible');
    }

    killScrollTriggers() {
      this.scrollTriggers.forEach((st) => st.kill());
      this.scrollTriggers = [];
      this.timelines.forEach((tl) => tl.kill());
      this.timelines = [];
    }

    initParallax() {
      if (!window.gsap || !window.ScrollTrigger) return;

      const isMobile = window.innerWidth <= 766;
      const colStartFactor = isMobile ? 0.2 : 0.75;
      const colEndFactor = 0.75;
      const amount = 10;

      this.root.querySelectorAll('.masonry-grid .main-col').forEach((column, index) => {
        const direction = index % 2 === 0 ? 1 : -1;
        const timeline = window.gsap.timeline({ paused: true });

        timeline.fromTo(
          column,
          {
            yPercent: amount * direction * colStartFactor,
            willChange: 'transform',
            transformOrigin: 'center center',
          },
          {
            yPercent: -amount * direction * colEndFactor,
            opacity: 1,
            duration: 1,
            ease: 'none',
          },
          0,
        );

        const trigger = window.ScrollTrigger.create({
          trigger: column,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          animation: timeline,
        });

        this.scrollTriggers.push(trigger);
        this.timelines.push(timeline);
      });
    }

    init() {
      this.killScrollTriggers();
      this.buildMasonry();
      this.columnCount = this.getColumnCount();
      this.initParallax();
      window.ScrollTrigger?.refresh();
    }

    destroy() {
      this.killScrollTriggers();
      this.destroyModalSwiper();
      clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.onResize);
    }
  }

  const instances = new Map();

  const boot = async () => {
    await waitForGsap();

    document.querySelectorAll('.sa-follow-us-root').forEach((root) => {
      const id = root.dataset.sectionId;
      if (instances.has(id)) {
        instances.get(id).destroy();
      }
      instances.set(id, new SaFollowUs(root));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.sa-follow-us-root');
    if (!root) return;
    boot();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('.sa-follow-us-root');
    if (!root) return;
    const instance = instances.get(root.dataset.sectionId);
    instance?.destroy();
    instances.delete(root.dataset.sectionId);
  });
})();
